import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import HotRanking from "@/pages/home/components/HotRanking";
import MovieGrid from "@/pages/home/components/MovieGrid";
import SubtitleZone from "@/pages/home/components/SubtitleZone";
import ShortFilmStrip from "@/pages/home/components/ShortFilmStrip";
import TopicWall from "@/pages/home/components/TopicWall";
import ViewingGuide from "@/pages/home/components/ViewingGuide";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRanking />
        <MovieGrid />
        <SubtitleZone />
        <ShortFilmStrip />
        <TopicWall />
        <ViewingGuide />
      </main>
      <SiteFooter />
    </div>
  );
}